module.exports = __webpack_public_path__ + "img/lock-open.a7247583.svg";